import Alpine from 'alpinejs';
import Flickity from 'flickity';
import 'flickity-fade';

document.addEventListener("alpine:init", () => {
    Alpine.data('strategyProfile', () => ({
        currentSlide: 0,
        totalSlides: 0,
        slider: null,
    
        init() {
            console.log("HELLO");
            console.log(Flickity.prototype);
            window.addEventListener('turbo:load', this.initSlider(), false);
            window.addEventListener('load', this.initSlider(), false); 
            this.initSlider();
    
            if ( document.querySelector('#save-strategy-button') != null ) {
                document.querySelector('#save-strategy-button').addEventListener('click', this.submitForm);
            }
        },
            
        initSlider() {
            if( document.querySelector('.strategy__carousel') != null ){ 
                this.slider = new Flickity( '.strategy__carousel', {
                    draggable: true, 
                    pageDots: false, 
                    prevNextButtons: false, 
                    contain: true, 
                    wrapAround: false, 
                    autoplay: false, 
                    adaptiveHeight: true,
                    selectedAttraction: 0.2,
                    friction: 1,
                    fade: true
                });
    
                document.addEventListener('click', function (event) {
                    if (event.target.dataset.linkToAddFieldId == null && event.target.dataset.linkToRemoveField) return;
                    window.dispatchEvent(new Event('resize'));
                }); 
    
                this.getTotalSlides();
            }     
        },

        goToSlide(index) {
            this.currentSlide = index;
            this.slider.select(this.currentSlide);

            this.$nextTick(() => {  
                // Find the active tab
                let activeTab = document.querySelector('.btn--tab.active');
                let headerTabsInner = document.querySelector('.header__tabs__inner');
            
                if (activeTab && headerTabsInner) {
                    let activeTabPosition = activeTab.getBoundingClientRect();
                    let headerTabsInnerPosition = headerTabsInner.getBoundingClientRect();
            
                    // Check if the active tab is out of view on the left or right
                    if (activeTabPosition.left < headerTabsInnerPosition.left) {
                        // Scroll left to bring it into view
                        headerTabsInner.scrollBy({ left: activeTabPosition.left - headerTabsInnerPosition.left, behavior: 'smooth' });
                    } else if (activeTabPosition.right > headerTabsInnerPosition.right) {
                        // Scroll right to bring it into view
                        headerTabsInner.scrollBy({ left: activeTabPosition.right - headerTabsInnerPosition.right, behavior: 'smooth' });
                    }
                }
            });
        },           
    
        getTotalSlides() {
            this.totalSlides = this.slider.slides.length;
        },
        
        submitForm() {
            document.getElementById('strategy-profile-form').submit();
        }
    }));
    
});